"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _themeOptimized = _interopRequireDefault(require("../themeOptimized"));

var _root = _interopRequireDefault(require("./style/root"));

var _mergeTheme = _interopRequireDefault(require("../style/mergeTheme"));

var Label = function Label(_ref) {
  var children = _ref.children,
      theme = _ref.theme,
      style = _ref.style,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["children", "theme", "style"]);
  var styleMemo = (0, _react.useMemo)(function () {
    return (0, _mergeTheme["default"])(theme, style);
  }, [style]);
  return _react["default"].createElement(_root["default"], (0, _extends2["default"])({}, rest, {
    style: styleMemo
  }), children);
};

var _default = (0, _themeOptimized["default"])(Label, 'label');

exports["default"] = _default;